"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPublisherData = void 0;
const web3_js_1 = require("@solana/web3.js");
const apy_1 = require("./apy");
const constants_1 = require("../constants");
const extractPublisherData = (poolData) => {
    return poolData.publishers
        .filter((publisher) => !publisher.equals(web3_js_1.PublicKey.default))
        .map((publisher, index) => ({
        pubkey: publisher,
        stakeAccount: poolData.publisherStakeAccounts[index] === undefined ||
            poolData.publisherStakeAccounts[index].equals(web3_js_1.PublicKey.default)
            ? null
            : poolData.publisherStakeAccounts[index],
        totalDelegation: (poolData.delState[index]?.totalDelegation ?? 0n) +
            (poolData.selfDelState[index]?.totalDelegation ?? 0n),
        totalDelegationDelta: (poolData.delState[index]?.deltaDelegation ?? 0n) +
            (poolData.selfDelState[index]?.deltaDelegation ?? 0n),
        selfDelegation: poolData.selfDelState[index]?.totalDelegation ?? 0n,
        selfDelegationDelta: poolData.selfDelState[index]?.deltaDelegation ?? 0n,
        delegationFee: poolData.delegationFees[index] ?? 0n,
        apyHistory: poolData.events
            .filter((event) => event.epoch > 0n)
            .map((event) => ({
            epoch: event.epoch,
            apy: (0, apy_1.convertEpochYieldToApy)((event.y * (event.eventData[index]?.otherRewardRatio ?? 0n)) /
                constants_1.FRACTION_PRECISION_N) *
                (0, apy_1.computeDelegatorRewardPercentage)(poolData.delegationFees[index] ?? 0n),
            selfApy: (0, apy_1.convertEpochYieldToApy)((event.y * (event.eventData[index]?.selfRewardRatio ?? 0n)) /
                constants_1.FRACTION_PRECISION_N),
        }))
            .sort((a, b) => Number(a.epoch) - Number(b.epoch)),
    }));
};
exports.extractPublisherData = extractPublisherData;
